import * as React from 'react';

import { motion } from 'framer-motion';

import styled from 'styled-components';

export interface PlusIconProps {
  className?: string;
  size?: number;
  close?: boolean;
  noAnimation?: boolean;
  isWhite?: boolean;
  onClick?: () => void;
}

export const PlusIcon: React.FC<PlusIconProps> = (props) => {
  const rotate = {
    rest: {
      rotate: 0,
      opacity: 1,
    },
    hover: {
      rotate: 90,
      transition: {
        ease: [0.0, 0.005, 0.2, 1.0],
        duration: 0.15,
      },
    },
    click: {
      opacity: 0,
    },
  };

  const closeVariant = {
    rest: {
      rotate: 45,
      opacity: 1,
    },
    hover: {
      rotate: -45,
      transition: {
        ease: [0.0, 0.005, 0.2, 1.0],
        duration: 0.15,
      },
    },
    click: {
      opacity: 0,
    },
  };

  return (
    <motion.svg
      viewBox="0 0 16 16"
      className={props.className}
      initial={props.close ? 'hover' : 'rest'}
      animate={props.close ? 'hover' : 'rest'}
      whileHover={props.close ? 'rest' : 'hover'}
      whileTap={props.close ? 'rest' : 'hover'}
      exit="click"
      onClick={props.onClick}
    >
      <motion.path
        variants={
          props.noAnimation ? undefined : props.close ? closeVariant : rotate
        }
        className={props.isWhite ? 'white' : ''}
        d="M13,7H9V3c0-0.55-0.45-1-1-1S7,2.45,7,3v4H3C2.45,7,2,7.45,2,8s0.45,1,1,1h4v4c0,0.55,0.45,1,1,1s1-0.45,1-1V9h4c0.55,0,1-0.45,1-1S13.55,7,13,7z"
      />
    </motion.svg>
  );
};

export default styled(PlusIcon)`
  width: ${(props) => (props.size ? `${props.size}px` : '16px')};
  height: ${(props) => (props.size ? `${props.size}px` : '16px')};

  path {
    fill: ${({ theme }) => theme.colors.primary};

    &.white {
      fill: ${({ theme }) => theme.colors.differentBackground};
    }
  }
`;
